module.exports = __webpack_public_path__ + "img/ellipse-r.741164ab.png";